import React from 'react'
import { Modal, ModalProps } from '@mui/material'

import XIcon from '../../../icons/XIcon'

import Spacer from '../../../atoms/Spacer'

import useStyles from './styles'

export interface MobileModalProps extends Omit<ModalProps, 'open'> {
  onClose: () => void
  title?: string
}

const MobileModal: React.FC<MobileModalProps> = ({
  onClose,
  children,
  title
}) => {
  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    onClose()
  }, [onClose])

  return (
    <Modal
      open
      onClose={() => handleClose()}
      BackdropProps={{ style: { backdropFilter: 'blur(10px)' } }}
    >
      <div className={classes.root}>
        <div className={classes.header}>
          {title && <div className={classes.title}>{title}</div>}

          <Spacer />

          <XIcon onClick={handleClose} className={classes.close} />
        </div>

        <div className={classes.children}>{children}</div>
      </div>
    </Modal>
  )
}

export default MobileModal
